/*
    Browser.jsx
    browser-related code
*/

// TODO: use this: https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser

export const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
export const isIE = () => navigator.userAgent.includes("MSIE ") || /Trident.*rv\:11\./.test(navigator.userAgent);
export const isFirefox = () => typeof InstallTrigger !== 'undefined';
export const isIPhone = () => navigator.platform.indexOf("iPhone") !== -1;
export const isIPod = () => navigator.platform.indexOf("iPod") !== -1;
export const isIPad = () => navigator.platform.indexOf("iPad") !== -1;

export const isWindows = () => /^(OS\/2|Pocket PC|Windows|Win(16|32|64|CE))$/i.test(navigator.platform);
export const isApple = () => (isSafari() || isIPhone() || isIPod() || isIPad()) && !window.MSStream;

export const navigateTo = url => window.history.pushState(null, null, url);

